import { Category } from '../types';
import { isPDFUrl, isYouTubeUrl } from '../typeValidators';

export default (url: string): Category => {
  let category: Category;
  if (isPDFUrl(url)) {
    category = Category.PDF;
  } else if (url.match(/.+?(twitter|x).com\/(?:.+?\/status|(?!i\/)[^/]+\/article)\/\d+\/?/)) {
    category = Category.Tweet;
  } else if (isYouTubeUrl(url)) {
    category = Category.Video;
  } else {
    category = Category.Article;
  }
  return category;
};
